export const API_ROOT = '//apis.manhattanprep.com/v1/'
// TODO [GitHub Issue]: Determine latest backend version in the deployment process
export const APP_VERSION = 2
export const LOGIN_URL = '//www.manhattanprep.com/'
export const LOGOUT_URL = '//www.manhattanprep.com/'
export const CART_URL = '//www.manhattanprep.com/:testline/cart/'
export const COURSE_FINDER_URL = '//www.manhattanprep.com/:testline/classes/'
export const LOGOUT_PATH = '/account/logout/index.cfm'
export const WORKSPACE_BASE_URL = '/path'
export const TOUR_COOKIE_NAME = 'MP-LMS-INTRO'
export const TEST_LINES = ['gmat', 'gre', 'lsat', 'college']
export const STUDENT_SERVICES_EMAIL = 'studentservices@manhattanprep.com'
export const STUDENT_SERVICES_PHONE = '800-576-4628'
export const EXAMS_RETURN_URL = 'https://www.manhattanprep.com/atlas/'
export const ZOOM_MAGIC_LINK = 'https://www.manhattanprep.com/live/:enrollmentId'

export const PROGRAM_CODE_MAPPING = {
  193: 'LSAT',
  196: 'GRE',
  203: 'GMAT',
  245: 'EA'
}

export const PROGRAM_ID_MAPPING = {
  'LSAT': 193,
  'GRE': 196,
  'GMAT': 203,
  'EA': 245
}

export const PROGRAM_ID_EXTENSION_MAP = {
  196: '30013369',
  203: '30014047',
  245: '30014047'
}

export const BS_SCREEN_SIZES = Object.freeze({
  small: 768,
  medium: 992,
  large: 1200
})

export const LSAC_ACCOUNT_TYPES = Object.freeze({
  free: 'free_account',
  paid: 'prep_plus_required'
})

export const LSAC_STORE_URL = 'https://enroll.manhattanprep.com/shoppingcart?classids=30013128'

export const VENDOR_SERVICE_CONFIG = Object.freeze({
  NEW_RELIC: {
    applicationId: '21005588',
    licenseKey: '84c5cfabdd'
  },
  SENTRY: {
    endpoint: 'https://1027942c65c245e3b7399a119af13003@app.getsentry.com/83763'
  },
  GOOGLE: {
    analytics: {
      id: 'UA-11069134-2'
    }
  }
})

// TODO: Update this for launch to both equal GTM-MTB788M
export const GTM_ID = 'GTM-MTB788M'

export const KBS_ENROLLMENT_PURCHASE_URL = ENV === 'production' ?
  '//enroll.manhattanprep.com/shoppingcart?classids=:productId&enrollmentId=:enrollmentId&quantity=:quantity' :
  '//kapqa1-kaptest2.cs34.force.com/shoppingcart?classids=:productId&enrollmentId=:enrollmentId&quantity=:quantity&v=3'

export const KBS_TUTORING_EXTENSION_PRODUCT_IDS = {
  lsat: '30012181',
  gre: '30012894',
  gmat: '30013975',
  ea: '30014036'
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/constants.ts